import React from 'react';
import { HeroSection } from '../components/home/HeroSection';
import { StatsSection } from '../components/home/StatsSection';
import { FeaturedProjects } from '../components/home/FeaturedProjects';
import { LatestBids } from '../components/home/LatestBids';
import { ProcurementQuickLinks } from '../components/home/ProcurementQuickLinks';
import { NewsSection } from '../components/home/NewsSection';
import { CTASection } from '../components/home/CTASection';
export function Home() {
  return <div data-id="element-728">
      <HeroSection data-id="element-729" />
      <StatsSection data-id="element-730" />
      <FeaturedProjects data-id="element-731" />
      <LatestBids data-id="element-732" />
      <ProcurementQuickLinks data-id="element-733" />
      <NewsSection data-id="element-734" />
      <CTASection data-id="element-735" />
    </div>;
}